import React from 'react';
import './TrustTechStudio.css';

function TrustTechStudio() {
  return (
    <div className="tts-container">
      <header className="tts-header">
        <p className="tts-message">Welcome to Your Bespoke K-R-O Experience (more luxurious and what I started with marketing back in March). Color schemes for font should only be between purple, blue or white. And the banners should be purple again with white font for content.</p>
      </header>
      <footer className="tts-footer">
        <span>&copy; {new Date().getFullYear()} Trust Tech Studio. All rights reserved.</span>
      </footer>
    </div>
  );
}

export default TrustTechStudio;
